(() => {
  if (window.__tanDiscoveryV34) return;
  window.__tanDiscoveryV34 = true;

  const normalize = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase(document.documentElement.lang || undefined)
    .replace(/\s+/g, ' ')
    .trim();

  const emit = (name, details = {}) => {
    const payload = {
      event_version: '1.0',
      language_code: String(document.documentElement.lang || '').slice(0, 20),
      ...details,
    };
    window.dispatchEvent(new CustomEvent('tan:discovery-event', { detail: { name, data: payload } }));
    try {
      window.Shopify?.analytics?.publish?.(`the_art_neon:${name}`, payload);
    } catch (_) {
      // Discovery remains fully usable when analytics is unavailable.
    }
  };

  document.querySelectorAll('[data-collection-description]').forEach((description) => {
    const button = description.parentElement?.querySelector('[data-description-toggle]');
    if (!button || description.scrollHeight <= 150) return;
    description.classList.add('is-collapsible');
    button.hidden = false;
    button.addEventListener('click', () => {
      const expanded = description.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    });
  });

  document.querySelectorAll('[data-collection-directory]').forEach((directory) => {
    const tabs = Array.from(directory.querySelectorAll('[data-directory-tab]'));
    const panels = Array.from(directory.querySelectorAll('[data-directory-panel]'));
    const cards = Array.from(directory.querySelectorAll('[data-directory-card]'));
    const input = directory.querySelector('[data-directory-filter]');
    const status = directory.querySelector('[data-directory-status]');
    const empty = directory.querySelector('[data-directory-empty]');
    let activeGroup = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.directoryTab || tabs[0]?.dataset.directoryTab;

    const setActive = (group, focus = false) => {
      activeGroup = group;
      tabs.forEach((tab) => {
        const selected = tab.dataset.directoryTab === group;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.directoryPanel !== group; });
      if (input) input.value = '';
      cards.forEach((card) => { card.hidden = false; });
      if (empty) empty.hidden = true;
      const visibleCount = cards.filter((card) => card.dataset.directoryGroup === group).length;
      if (status) status.textContent = status.dataset.groupLabel.replace('[count]', String(visibleCount));
      emit('discovery_group_selected', { group_id: group, visible_count: visibleCount });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActive(tab.dataset.directoryTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        setActive(tabs[nextIndex].dataset.directoryTab, true);
      });
    });

    if (activeGroup) {
      panels.forEach((panel) => { panel.hidden = panel.dataset.directoryPanel !== activeGroup; });
      const initialCount = cards.filter((card) => card.dataset.directoryGroup === activeGroup).length;
      if (status) status.textContent = status.dataset.groupLabel.replace('[count]', String(initialCount));
    }

    input?.addEventListener('input', () => {
      const term = normalize(input.value).slice(0, 80);
      let matches = 0;
      if (!term) {
        panels.forEach((panel) => { panel.hidden = panel.dataset.directoryPanel !== activeGroup; });
        cards.forEach((card) => { card.hidden = false; });
        const visibleCount = cards.filter((card) => card.dataset.directoryGroup === activeGroup).length;
        if (status) status.textContent = status.dataset.groupLabel.replace('[count]', String(visibleCount));
        if (empty) empty.hidden = true;
        return;
      }

      panels.forEach((panel) => { panel.hidden = false; });
      cards.forEach((card) => {
        const match = normalize(card.dataset.searchText).includes(term);
        card.hidden = !match;
        if (match) matches += 1;
      });
      panels.forEach((panel) => {
        panel.hidden = !panel.querySelector('[data-directory-card]:not([hidden])');
      });
      if (empty) empty.hidden = matches !== 0;
      if (status) status.textContent = status.dataset.searchLabel.replace('[count]', String(matches));
    });

    directory.querySelectorAll('[data-directory-card] > a').forEach((link) => {
      link.addEventListener('click', () => {
        emit('discovery_collection_opened', {
          group_id: link.closest('[data-directory-card]')?.dataset.directoryGroup || 'unknown',
          collection_position: Number(link.closest('[data-directory-card]')?.dataset.position || 0),
        });
      });
    });
  });

  document.querySelectorAll('[data-search-scope]').forEach((scope) => {
    scope.addEventListener('click', () => {
      emit('search_scope_selected', {
        scope_id: String(scope.dataset.scope || 'all').slice(0, 20),
      });
    });
  });

  const fourOhFour = document.querySelector('[data-tan-404]');
  if (fourOhFour && !document.documentElement.classList.contains('shopify-design-mode')) {
    const rawPath = window.location.pathname || '/';
    const segments = rawPath.split('/').filter(Boolean);
    const unsafe = /@|%40|(?:^|\/)(?:account|orders?|customers?|checkouts?)(?:\/|$)/i.test(rawPath)
      || segments.some((segment) => /\d{8,}/.test(segment) || /^[a-f0-9_-]{24,}$/i.test(segment));
    const cleanPath = unsafe
      ? ''
      : rawPath.replace(/\/{2,}/g, '/').slice(0, 180);
    let referrerGroup = 'direct';
    try {
      if (document.referrer) referrerGroup = new URL(document.referrer).origin === window.location.origin ? 'internal' : 'external';
    } catch (_) {
      referrerGroup = 'unknown';
    }
    emit('discovery_404_view', {
      clean_path: cleanPath,
      path_available: Boolean(cleanPath),
      path_family: String(segments[0] || 'root').replace(/[^a-z0-9_-]/gi, '').slice(0, 30),
      path_depth: Math.min(segments.length, 10),
      referrer_group: referrerGroup,
      has_query: Boolean(window.location.search),
    });
  }
})();
